const DOMAIN_PRODUCTION = "waves.dive.tech";
const DOMAIN_STAGING = "staging.waves.dive.tech";
const DOMAIN_DEVELOPMENT = "dev.waves.clients.dive.tech";

const DEFAULT_API_URL = window.location.origin;

const defaults = {
  KEYCLOAK_URL: "https://auth.dev.waves.clients.dive.tech",
  KEYCLOAK_REALM: "ispd",
  KEYCLOAK_CLIENT_ID: "waves",
  CLIENT_API_URL: DEFAULT_API_URL,
  MODEL_API_URL: DEFAULT_API_URL,
  SCENARIO_API_URL: DEFAULT_API_URL,
  USER_API_URL: DEFAULT_API_URL,
  ENVIRONMENT: "local",
  FIREBASE_API_KEY: "",
  FIREBASE_AUTH_DOMAIN: "",
  FIREBASE_PROJECT_ID: "",
  FIREBASE_STORAGE_BUCKET: "",
  FIREBASE_MESSAGING_SENDER_ID: "",
  FIREBASE_APP_ID: "",
  FIREBASE_MEASUREMENT_ID: "",
  GTM_ID: ""
};

const variables = {
  local: {
    ...defaults,
    KEYCLOAK_URL:
      (import.meta.env.VITE_KEYCLOAK_URL as string) || defaults.KEYCLOAK_URL,
    KEYCLOAK_REALM:
      (import.meta.env.VITE_KEYCLOAK_REALM as string) ||
      defaults.KEYCLOAK_REALM,
    KEYCLOAK_CLIENT_ID:
      (import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string) ||
      defaults.KEYCLOAK_CLIENT_ID,
    CLIENT_API_URL:
      (import.meta.env.VITE_CLIENT_API_URL as string) ||
      defaults.CLIENT_API_URL,
    MODEL_API_URL:
      (import.meta.env.VITE_MODEL_API_URL as string) || defaults.MODEL_API_URL,
    SCENARIO_API_URL:
      (import.meta.env.VITE_SCENARIO_API_URL as string) ||
      defaults.SCENARIO_API_URL,
    USER_API_URL:
      (import.meta.env.VITE_USER_API_URL as string) || defaults.USER_API_URL,
    FIREBASE_API_KEY: (import.meta.env.VITE_FIREBASE_API_KEY as string) || "",
    FIREBASE_AUTH_DOMAIN:
      (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string) || "",
    FIREBASE_PROJECT_ID:
      (import.meta.env.VITE_FIREBASE_PROJECT_ID as string) || "",
    FIREBASE_STORAGE_BUCKET:
      (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string) || "",
    FIREBASE_MESSAGING_SENDER_ID:
      (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string) || "",
    FIREBASE_APP_ID: (import.meta.env.VITE_FIREBASE_APP_ID as string) || "",
    FIREBASE_MEASUREMENT_ID:
      (import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string) || "",
    GTM_ID: (import.meta.env.VITE_GTM_ID as string) || ""
  },
  development: {
    ...defaults,
    KEYCLOAK_URL: "https://auth.dev.waves.clients.dive.tech",
    KEYCLOAK_REALM: "ispd",
    KEYCLOAK_CLIENT_ID: "waves",
    ENVIRONMENT: "development",
    FIREBASE_API_KEY: "AIzaSyBtoSU399pmsXggEdVJSqW1nPltkaImuqQ",
    FIREBASE_AUTH_DOMAIN: "waves-dev-249ba.firebaseapp.com",
    FIREBASE_PROJECT_ID: "waves-dev-249ba",
    FIREBASE_STORAGE_BUCKET: "waves-dev-249ba.firebasestorage.app",
    FIREBASE_MESSAGING_SENDER_ID: "698684843560",
    FIREBASE_APP_ID: "1:698684843560:web:830fab3baaca7efa2cf71d",
    FIREBASE_MEASUREMENT_ID: "G-6B02N6V81K",
    GTM_ID: "GTM-NR63CCT4"
  },
  staging: {
    ...defaults,
    KEYCLOAK_URL: "https://auth.waves.staging.dive.tech",
    KEYCLOAK_REALM: "ispd",
    KEYCLOAK_CLIENT_ID: "waves",
    ENVIRONMENT: "staging",
    FIREBASE_API_KEY: "YOUR_STAGING_API_KEY",
    FIREBASE_AUTH_DOMAIN: "YOUR_STAGING_PROJECT_ID.firebaseapp.com",
    FIREBASE_PROJECT_ID: "YOUR_STAGING_PROJECT_ID",
    FIREBASE_STORAGE_BUCKET: "YOUR_STAGING_PROJECT_ID.appspot.com",
    FIREBASE_MESSAGING_SENDER_ID: "YOUR_STAGING_SENDER_ID",
    FIREBASE_APP_ID: "YOUR_STAGING_APP_ID",
    FIREBASE_MEASUREMENT_ID: "G-XXXXXXXXX",
    GTM_ID: "GTM-STAGING"
  },
  production: {
    ...defaults,
    KEYCLOAK_URL: "https://auth.waves.dive.tech",
    KEYCLOAK_REALM: "ispd",
    KEYCLOAK_CLIENT_ID: "waves",
    ENVIRONMENT: "production",
    FIREBASE_API_KEY: "AIzaSyCh_4gHnPjoZuOuY9mKNVGbxXCV_QF1OEo",
    FIREBASE_AUTH_DOMAIN: "waves-prod-bf5da.firebaseapp.com",
    FIREBASE_PROJECT_ID: "waves-prod-bf5da",
    FIREBASE_STORAGE_BUCKET: "waves-prod-bf5da.firebasestorage.app",
    FIREBASE_MESSAGING_SENDER_ID: "686876195723",
    FIREBASE_APP_ID: "1:686876195723:web:df830ffcdc61111bff8d8e",
    FIREBASE_MEASUREMENT_ID: "G-XFJYGMZE5Q",
    GTM_ID: "GTM-WPQ4GJF3"
  }
};

const getVariables = () => {
  if (window.location.host === DOMAIN_PRODUCTION) {
    return variables.production;
  }

  if (window.location.host === DOMAIN_STAGING) {
    return variables.staging;
  }

  if (window.location.host === DOMAIN_DEVELOPMENT) {
    return variables.development;
  }

  return variables.local;
};

export const {
  KEYCLOAK_URL,
  KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID,
  CLIENT_API_URL,
  MODEL_API_URL,
  SCENARIO_API_URL,
  USER_API_URL,
  ENVIRONMENT,
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  GTM_ID
} = getVariables();
